"use client";
// РУКА 2. Слайды наверху главной. Меняются сами каждые 7 секунд (как в макете), на наведении — пауза.
// Тексты приходят со страницы: из макета, а магазин сможет править их через Руку 3.
import { useEffect, useState } from "react";
import Link from "next/link";

export type Slide = {
  kicker: string;
  title: string;
  text: string;
  img?: string; // фото на фоне — из макета
  cta?: { href: string; label: string };
  link?: { href: string; label: string };
};

export function HeroSlider({ slides }: { slides: Slide[] }) {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const n = slides.length;

  useEffect(() => {
    if (paused || n < 2) return;
    const t = setInterval(() => setI((v) => (v + 1) % n), 7000);
    return () => clearInterval(t);
  }, [paused, n]);

  const s = slides[i];
  // Вид — как в макете (Р-020): .hero-s, фото на фоне, кнопки, стрелки и точки
  return (
    <div className="hero-s" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      {/* eslint-disable-next-line @next/next/no-img-element -- фон из макета, своё кадрирование в стилях */}
      {s.img ? <img className="bg" src={s.img} alt="" /> : null}
      <div className="in">
        <div className="eb">{s.kicker}</div>
        <h2>{s.title}</h2>
        <p className="sm">{s.text}</p>
        <div className="row" style={{ marginTop: 16 }}>
          <Link className="b sm" href={s.cta?.href ?? "/catalog"}>
            {s.cta?.label ?? "Открыть каталог"}
          </Link>
          {s.link ? (
            <Link className="b dk sm" href={s.link.href}>
              {s.link.label}
            </Link>
          ) : null}
        </div>
      </div>
      {n > 1 ? (
        <div className="hero-nav">
          <button type="button" className="arr" aria-label="Предыдущий слайд" onClick={() => setI((i - 1 + n) % n)}>
            ←
          </button>
          <div className="hero-dots">
            {slides.map((_, k) => (
              <button key={k} type="button" className={k === i ? "on" : ""} aria-label={`Слайд ${k + 1}`} aria-current={k === i} onClick={() => setI(k)} />
            ))}
          </div>
          <button type="button" className="arr" aria-label="Следующий слайд" onClick={() => setI((i + 1) % n)}>
            →
          </button>
        </div>
      ) : null}
    </div>
  );
}
